import { takeLatest, all, put, call } from 'redux-saga/effects';
import Actions from "../action";
import { doGet, doPost, doPostFormData} from '../../service/index';
import END_POINTS from './EndPoints';
import { EDIT_HOSTELLER_REQUEST, ADD_NEW_PERSON_REQUEST, GET_VIDEO_LINK_REQUEST, APPROVAL_REQUEST   } from '../action/HostellerDataUpdateAction';

export function* hostellerdataupdateSaga({ params, callback }) {
    try {
        const response = yield doPostFormData(END_POINTS.HOSTELLER_DATA_UPDATE, params)
        const updatedData = { ...params, ...response?.data }; 
        yield put(Actions.editHostellerSuccess(updatedData));
        if (callback) callback(response);
    } catch (error) {
        yield put(Actions.editHostellerFailure({ error }));
        if (callback) callback(error);
    }
}

export function* addNewPersonSaga({ params, callback }) {
    try {
        const response = yield doPostFormData(
            END_POINTS.ADD_NEW_PERSON,
            params // FormData
        );

        yield put(Actions.addNewPersonSuccess(response));
        callback?.(response);
    } catch (error) {
        yield put(Actions.addNewPersonFailure({ error }));
        callback?.(error);
    }
}


export function* hostelListSelectSaga({ params, callback }) {
    try {
        const response = yield doGet(END_POINTS.HOSTEL_LIST_SELECT, params)
        yield put(Actions.hostelListSelectSuccess(response));
        if (callback) {
            callback(response)
        }
    } catch (error) {
        yield put(Actions.hostelListSelectFailure({ error }));
        if (callback) {
            callback(error)
        }
    }
}

export function* ApprovalSaga({ params, callback }) {
    try {
        const response = yield doPost(END_POINTS.APPROVAL_API, params)
        yield put(Actions.sendApprovalSuccess(response));
           callback?.(response);
    } catch (error) {
        yield put(Actions.sendApprovalFailure({ error }));
        callback?.(error);
    
    }
}

export function* getPersonVideoSaga({ params, callback }) {
    try {
        const response = yield doGet(END_POINTS.GET_VIDEO_LINK, params)
        yield put(Actions.getPersonVideoSuccess(response));
        if (callback) {
            callback(response)
        }
    } catch (error) {
        yield put(Actions.getPersonVideoFailure({ error }));
        if (callback) {
            callback(error)
        }
    }
}
export default function* hostellerdataupdateWatcher() {
    yield all([
        takeLatest(EDIT_HOSTELLER_REQUEST, hostellerdataupdateSaga),
        takeLatest(ADD_NEW_PERSON_REQUEST, addNewPersonSaga),
        takeLatest(GET_VIDEO_LINK_REQUEST, getPersonVideoSaga),
        takeLatest(APPROVAL_REQUEST,ApprovalSaga )

    ]);
}



